(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lovea-carousel-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track = document.querySelector('[data-lp-video-track]');
  if (!track) return;
  var cards = Array.prototype.slice.call(track.querySelectorAll('[data-lp-card]'));
  var videos = cards.map(function (card) { return card.querySelector('video'); });
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var active = {};
  var manualPause = {};

  function indexOf(video) {
    return videos.indexOf(video);
  }

  function pause(video) {
    if (video && !video.paused) video.pause();
    var card = video && video.closest('[data-lp-card]');
    if (card) card.classList.remove('playing');
    if (video) delete active[indexOf(video)];
  }

  function play(video) {
    if (reduceMotion) return;
    if (video.paused) {
      var card = video.closest('[data-lp-card]');
      var p = video.play();
      if (p && p.then) {
        p.then(function () { if (card) card.classList.add('playing'); }).catch(function () {});
      }
      active[indexOf(video)] = video;
    }
  }

  function pauseAll() {
    videos.forEach(pause);
  }

  function hydrate(video) {
    if (video.src || !video.dataset.lpSrc) return;
    video.src = video.dataset.lpSrc;
    video.preload = 'metadata';
  }

  var section = track.closest('.video-section');
  if (section && 'IntersectionObserver' in window) {
    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          pauseAll();
          active = {};
        }
      });
    }, { threshold: 0.05 });
    sectionObserver.observe(section);
  }

  if ('IntersectionObserver' in window) {
    var nearObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) hydrate(entry.target.querySelector('video'));
      });
    }, { rootMargin: '300px 100px', threshold: 0.01 });
    cards.forEach(function (card) { nearObserver.observe(card); });

    var viewObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('video');
        var idx = indexOf(video);
        if (entry.isIntersecting) {
          delete manualPause[idx];
          play(video);
        } else {
          pause(video);
        }
      });
    }, { rootMargin: '0px', threshold: 0.05 });
    cards.forEach(function (card) { viewObserver.observe(card); });
  }

  cards.forEach(function (card) {
    var video = card.querySelector('video');
    card.addEventListener('click', function (e) {
      var muteBtn = e.target.closest('[data-lp-mute]');
      if (muteBtn) {
        video.muted = !video.muted;
        muteBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        muteBtn.setAttribute('aria-label', video.muted ? 'Activer le son' : 'Couper le son');
        return;
      }
      var idx = indexOf(video);
      if (video.paused) {
        delete manualPause[idx];
        hydrate(video);
        play(video);
      } else {
        pause(video);
        manualPause[idx] = true;
      }
    });
  });

  var prev = document.querySelector('[data-lp-video-prev]');
  var next = document.querySelector('[data-lp-video-next]');
  function step() {
    var first = track.querySelector('[data-lp-card]');
    if (!first) return 260;
    var gap = 18;
    var style = window.getComputedStyle ? window.getComputedStyle(track) : null;
    if (style && style.gap) {
      var parsed = parseFloat(style.gap);
      if (!isNaN(parsed)) gap = parsed;
    }
    return first.getBoundingClientRect().width + gap;
  }
  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
  if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
})();

  } catch(e) { console.error(e); }
})();
})();
